import React, { useEffect, useState } from 'react';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';
import { db } from '../FireBase'; // Import Firestore
import { Container, Table, Button,Pagination } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loading from '../components/Loading';

const BlockedUsers = () => {
    const [blockedUsers, setBlockedUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 20;

    const fetchBlockedUsers = async () => {
        try {
            setLoading(true);
            const subscriptionsQuery = query(collection(db, 'subscriptions'), where('isActive', '==', false));
            const subscriptionsSnapshot = await getDocs(subscriptionsQuery);

            const subscriptionsData = subscriptionsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
            const userPromises = subscriptionsData.map(async (subscription) => {
                const userRef = query(collection(db, 'users'), where('cusmid', '==', subscription.userId));
                const userSnapshot = await getDocs(userRef);
                if (!userSnapshot.empty) {
                    const userDoc = userSnapshot.docs[0];
                    const schemeRef = doc(db, 'schemes', subscription.schemeId);
                    const schemeDoc = await getDoc(schemeRef);
                    const schemeName = schemeDoc.exists() ? schemeDoc.data().name : 'Unknown Scheme';

                    return {
                        id: userDoc.id,
                        ...userDoc.data(),
                        totalMonths: subscription.totalMonths,
                        monthsPaid: subscription.paidMonths,
                        isActive: subscription.isActive,
                        cusStatus: subscription.status,
                        schemeName,
                        schemeId:subscription.schemeId,
                    };
                } else {
                    console.log(`No such user document for userId: ${subscription.userId}`);
                    return null;
                }
            });

            const usersData = await Promise.all(userPromises);
            setBlockedUsers(usersData.filter(user => user !== null));
            setLoading(false);
        } catch (error) {
            console.error('Error fetching blocked users:', error);
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBlockedUsers();
    }, []);

    if (loading) {
        return (
            <div className="loading-screen">
                <Loading />
            </div>
        );
    }
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = blockedUsers.slice(indexOfFirstItem, indexOfLastItem);
  
    const paginate = (pageNumber) => setCurrentPage(pageNumber);
  
    return (
        <Container fluid className="mt-5">
            <h1>Blocked Users</h1>
            <Table striped bordered hover responsive>
                <thead>
                    <tr className='scheme-det-font-head'>
                        <th>Cus ID</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Phone</th>
                        <th>Dues</th>
                        <th>Status</th>
                        <th>Scheme</th>
                      
                    </tr>
                </thead>
                <tbody>
                    {currentItems.map((user, index) => (
                        <tr key={index} className='scheme-det-font'>
                            <td><Link to={`/customerdetails/${user.cusmid}`} style={{ textDecoration: 'none', color: 'blue' }}>{user.cusmid}</Link></td>
                            <td>{user.name}</td>
                            <td>{user.email}</td>
                            <td>{user.phone}</td>
                            <td>{user.monthsPaid}/{user.totalMonths}</td>
                            <td>{user.isActive ? 'Active' : 'Blocked'}</td>
                            <td>
                                 <Link to={`/scheme/${user.schemeId}`} style={{ textDecoration: 'none', color: 'blue' }}>
                                    {user.schemeName}
                                 </Link>   
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <Pagination>
              {Array.from({ length: Math.ceil(blockedUsers.length / itemsPerPage) }, (_, index) => (
                  <Pagination.Item
                      key={index + 1}
                      active={index + 1 === currentPage}
                      onClick={() => paginate (index + 1)}                        
                  >
                      {index + 1}
                  </Pagination.Item>
              ))}
            </Pagination>
        </Container>
    );
};

export default BlockedUsers;